import { Col, Container, Row } from "react-bootstrap";

import { useEffect, useState } from "react";
import { FaArrowLeft } from "react-icons/fa6";
import { MdCalendarMonth } from "react-icons/md";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { blogData } from "../blogs/Blog";
import styles from "./blogContent.module.scss";
import Header from "../../components/header/Header";
import { Footer } from "../../components/footer/Footer";
import { data1, data2, data3 } from "../../common/dummydata/Dummy";

const BlogContent = () => {
  const { id } = useParams<{ id: string }>(); // Extract the image URL from the URL
  const navigate = useNavigate();
  const blogIndex = parseInt(id || "", 10) - 1;
  const blogImage = blogData[blogIndex]?.imgSrc;

  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Initial check for screen size on component mount
    handleResize();

    // Event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <>
      <Container>
        <div className={styles.header_wrapper}>
          <Header />
        </div>
        <div className={styles.main_wrapper}>
          <div
            onClick={() => {
              navigate(-1);
            }}
            className={styles.backbtn}
          >
            <FaArrowLeft />
            <button> Back</button>
          </div>
          <div className={styles.blogimg}>
            {/**if blogImage is true then show the blogImage  */}
            {blogImage && <img src={blogImage} alt="" />}
          </div>
          <div
            style={{ whiteSpace: "pre-line" }}
            className={styles.blogContentText}
          >
            {/* <div className={styles.date}>
              {" "}
              <MdCalendarMonth />
              <span>2 Oct,2023</span>
            </div> */}

            <h2>{location?.state?.title}</h2>

            <p>
              {" "}
              {id === "1" ? data1?.data : id === "2" ? data2.data : data3?.data}
            </p>
          </div>
          {/* <div className={styles.quotesection}>
            <img src={quotesimg} alt="" />
            <h4>
              “In a world older and more complete than ours they move finished
              and complete, gifted with extensions of the senses we have lost or
              never attained, living by voices we shall never hear.”
            </h4>
          </div> */}
          {/* <div className={styles.textcontent}>
            <p>
              It is a long established fact that a reader will be distracted by
              the readable content of a page when looking at its layout. The
              point of using Lorem Ipsum is that it has a more-or-less normal
              distribution of letters, as opposed to using 'Content here,
              content here', making it look like readable English. Many desktop
              publishing packages and web page editors now use Lorem Ipsum as
              their default model text, and a search for 'lorem ipsum' will
              uncover many web sites still in their infancy. Various versions
              have evolved over the years, sometimes by accident, sometimes on
              purpose.
              <br />
              <br /> Contrary to popular belief, Lorem Ipsum is not simply
              random text. It has roots in a piece of classical Latin literature
              from 45 BC, making it over 2000 years old. Richard McClintock, a
              Latin professor at Hampden-Sydney College in Virginia, looked up
              one of the more obscure Latin words, consectetur, from a Lorem
              Ipsum passage, and going through the cites of the word in
              classical literature, discovered the undoubtable source. Lorem
              Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus
              Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero,
              written in 45 BC. This book is a treatise on the theory of ethics,
              very popular during the Renaissance. The first line of Lorem
              Ipsum, "Lorem ipsum dolor sit amet.
            </p>
          </div> */}
          <hr />

          <div className={styles.moreblog}>
            <p>_______ Related _______</p>
            <h2>More from the blog</h2>
          </div>
          <div>
            <div className={styles.blogs_main}>
              {blogData.map((item, index) => {
                return (
                  <>
                    {index < 3 ? (
                      <div
                        onClick={() => {
                          navigate(`/blog/${index + 1}`, { state: item });
                        }}
                        className={styles.blogSection}
                      >
                        <div>
                          {" "}
                          <img src={item.imgSrc} alt="" />
                        </div>
                        <div className={styles.blogContentText}>
                          <h5>{item.title}</h5>
                          <p>{item.content}</p>
                          <div className={styles.date}>
                            {" "}
                            <MdCalendarMonth />
                            <span>{item.date}</span>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                );
              })}
            </div>
          </div>
        </div>
      </Container>
      <Footer />
    </>
  );
};

export default BlogContent;
